export default (questionnaire) => (Object.assign(Object.assign({}, questionnaire), { createdAt: new Date(questionnaire.createdAt) }));
